module.exports = __webpack_public_path__ + "static/media/test-icon.fd96232b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/test-icon.svg
// module id = 658
// module chunks = 0